// src/neetjee_guru/components/academicPlanner/ShiftScheduleModal.js
import React, { Component } from "react";
import { Modal, Button, Form } from "react-bootstrap";

class ShiftScheduleModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fromDate: "",
      shiftDays: 1,
      reason: "Rain / Unexpected Holiday Offset"
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.show !== this.props.show && this.props.show) {
      const todayStr = new Date().toISOString().split("T")[0];
      this.setState({
        fromDate: todayStr,
        shiftDays: 1,
        reason: "Rain / Unexpected Holiday Offset"
      });
    }
  }

  handleSubmit = (e) => {
    e.preventDefault();
    const { onShiftSchedule, onHide } = this.props;
    const { fromDate, shiftDays, reason } = this.state;

    if (!fromDate) return;

    if (onShiftSchedule) {
      onShiftSchedule(fromDate, parseInt(shiftDays, 10), reason);
    }
    onHide();
  };

  render() {
    const { show, onHide, streamName } = this.props;
    const { fromDate, shiftDays, reason } = this.state;

    return (
      <Modal show={show} onHide={onHide} centered className="shift-schedule-modal">
        <Modal.Header closeButton className="bg-warning text-dark">
          <Modal.Title className="h6 font-weight-bold m-0">
            <i className="fal fa-calendar-plus mr-2" /> Bulk Shift Schedule Dates
          </Modal.Title>
        </Modal.Header>

        <Form onSubmit={this.handleSubmit}>
          <Modal.Body>
            <div className="alert alert-info py-2 small mb-3">
              <i className="fal fa-info-circle mr-1" />
              Shifting schedule dates for stream: <strong>{streamName}</strong>. All subsequent topics starting from the selected date will move by the offset.
            </div>

            <Form.Group className="mb-3">
              <Form.Label className="small font-weight-bold">Starting Shift Date</Form.Label>
              <Form.Control
                type="date"
                size="sm"
                required
                value={fromDate}
                onChange={(e) => this.setState({ fromDate: e.target.value })}
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label className="small font-weight-bold">Offset Days (+ / -)</Form.Label>
              <Form.Control
                type="number"
                size="sm"
                required
                min="-30"
                max="30"
                value={shiftDays}
                onChange={(e) => this.setState({ shiftDays: e.target.value })}
              />
              <Form.Text className="text-muted small">
                Enter +1 to push schedule forward by 1 day, or -1 to bring it earlier.
              </Form.Text>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label className="small font-weight-bold">Reason for Shift</Form.Label>
              <Form.Control
                type="text"
                size="sm"
                placeholder="Reason..."
                value={reason}
                onChange={(e) => this.setState({ reason: e.target.value })}
              />
            </Form.Group>
          </Modal.Body>

          <Modal.Footer>
            <Button variant="secondary" size="sm" onClick={onHide}>
              Cancel
            </Button>
            <Button variant="warning" size="sm" type="submit" className="font-weight-bold">
              <i className="fal fa-check mr-1" /> Execute Bulk Shift
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    );
  }
}

export default ShiftScheduleModal;
